import { fmt } from "@/lib/format";
import { useTab } from "@/hooks/useTab";
import { useFilters } from "@/hooks/useFilters";
import { KpiCard } from "@/components/cards/KpiCard";
import { MessagesArea } from "@/components/charts/MessagesArea";
import { ActiveUsersBars } from "@/components/charts/ActiveUsersBars";
import { EmptyState, ErrorState, SectionTitle, TabSkeleton } from "./shared";

/** Tab 8 — Pulse. KPIs + monthly message area chart + active users bar. */
export function PulseTab() {
  const { filters } = useFilters();
  const { data, isPending, error } = useTab("pulse", filters);

  if (isPending) return <TabSkeleton />;
  if (error) return <ErrorState error={error} />;
  if (!data) return <EmptyState title="Sin datos de pulso." />;

  const { kpis } = data;

  return (
    <div className="flex flex-col gap-8">
      <section className="grid grid-cols-4 gap-3">
        <KpiCard label="Usuarios activos" value={fmt(kpis.active_users_total)} />
        <KpiCard label="Mensajes" value={fmt(kpis.messages_total)} />
        <KpiCard
          label="Conversaciones"
          value={fmt(kpis.conversations_total)}
        />
        <KpiCard label="Créditos" value={fmt(kpis.credits_total)} />
      </section>

      <section className="rounded-[20px] border border-border-1 bg-white/[0.02] p-6">
        <SectionTitle>Mensajes por día</SectionTitle>
        {data.monthly_messages.length === 0 ? (
          <EmptyState title="Sin datos mensuales." />
        ) : (
          <MessagesArea data={data.monthly_messages} />
        )}
      </section>

      <section className="rounded-[20px] border border-border-1 bg-white/[0.02] p-6">
        <SectionTitle>Usuarios activos por semana</SectionTitle>
        {data.active_users_daily.length === 0 ? (
          <EmptyState title="Sin datos." />
        ) : (
          <ActiveUsersBars data={data.active_users_daily} />
        )}
      </section>
    </div>
  );
}
